<template>
  <text-input v-bind="$attrs" :placeholder="$t(props.placeholder)">
    <template #prepend-inner>
      <Icon :icon="SearchSvg" :size="IconSize.SM" class="mr-1" />
    </template>
  </text-input>
</template>

<script setup>
import { TextInput } from '../text-input';
import { Icon, IconSize } from '@/components/icon';
import SearchSvg from '~/assets/icons/search.svg?component';

const props = defineProps({
  placeholder: {
    type: String,
    default: 'common.search',
  },
});
</script>
